import { useState } from "react";
import s from "./ProductImageGallery.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Zoom,
  Keyboard,
  Mousewheel,
  Autoplay,
  EffectFade,
  Pagination,
} from "swiper/modules";
import {cn} from "@/lib/utils.js";
import { Description, DialogBackdrop, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
export default function ProductImageGallery({ open = false, images, onClose }) {
  const [currentImage, setCurrentImage] = useState(images[0]);
  const [swiper, setSwiper] = useState(null);
  
  const overlayClassNames = cn(s.overlay, 'inset-0 fixed bg-black');
  const contentClassNames = cn(s.content, '', { "animate-contentShow": open });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogBackdrop className={overlayClassNames} />

      <DialogPanel className={contentClassNames}>

        <div className='flex flex-col xl:flex-row h-full w-full'>
          <div className='relative order-1 xl:order-2 flex flex-grow justify-center items-center h-[calc(100%-32px)] xl:h-full w-full xl:w-[calc(100%-128px)]'>
            <Swiper
              navigation
              zoom
              keyboard
              // autoplay
            pagination
              modules={[
                Navigation,
                Zoom,
                Keyboard,
                Mousewheel,
                EffectFade,
                Autoplay,
                // Pagination,
              ]}
              slidesPerView={1}
              className='h-full w-full'
              effect='fade'
              speed={300}
              onSwiper={(swiper) => {
                setSwiper(swiper);
              }}
            >
              {images.map((image, i) => {
                const imageUrl = image.image.url
                return (
                  <SwiperSlide
                    className='h-full w-full'
                    key={`product-image-${i}`}
                  >
                    <div className='flex items-center justify-center relative h-full w-full'>
                      <img
                        src={imageUrl}
                        width={image.width}
                        height={image.height}
                        // className="size-full"
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>

          <div className='h-32 flex-none w-full xl:w-[128px] order-2 xl:order-1'>
            <ul className='flex xl:flex-col xl:space-y-2'>
              {images.length > 1 && images.map((image, index) => {

                const imageUrl = image.thumbnail.url;
                return (
                  <li
                    onClick={() => {
                      setCurrentImage(image);
                      swiper.slideTo(index);
                    }}
                    className='cursor-pointer border-gray-100 p-4 hover:border-b-gray-200 hover:border-t-gray-200'
                  >
                    <img
                      src={imageUrl}
                      width={image.thumbnail.width}
                      height={image.thumbnail.height}
                      className="size-16"
                      itemProp="image"
                    />
                  </li>
                );
              })}
            </ul>
          </div>
          <button
            onClick={onClose}
            className='text-black bg-gray-100 hover:bg-gray-200 focus:shadow absolute top-[25px] right-[25px] inline-flex h-[75px] w-[75px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none text-5xl font-thin z-[999999]'
          >
            &times;
          </button>
        </div>
      </DialogPanel>
    </Dialog>
  );
}
